import WithSidebar from 'Layout/WithSidebar';
import { relatedProductPageTitles } from 'components/ProductSideBar/mockData';
import './styles.scss';
import image from 'images/small-images-inside-text/wuxal.jpg';
import aboutImage from 'images/info-image-2.jpg';
import { LabelButton } from 'components/buttons/LabelButton/LabelButton';
import GradientText from 'components/GradientText';
import ProductItemsBox from 'components/ProductItemsBox';
import { products, vegatables, vegatables2 } from 'components/ProductItemsBox/mockData';
import GeneralInfoBox from 'components/GeneralInfoBox';
import { Button } from 'components/buttons/Button/Button';
import BenefitsBox from 'components/BenefitsBox';
import ProductSideBar from 'components/ProductSideBar';
import { data2 } from 'components/BenefitsBox/mockData';

const RelatedProduct = () => {
    return (
        <div className="container">
            <div className="inner-container">
                <div className="main-text-container">
                    <LabelButton>about product</LabelButton>
                    <GradientText>
                        Highly concentrated <br /> suspension of
                        <img src={image} alt="decor" />
                        <em>Wuxal P Max New</em>
                    </GradientText>
                    <div className="offset-left-4 max-width-760">
                        <GradientText size="small">
                            Highly concentrated suspension with a high content of phosphorus and zinc, which has
                            <em>
                                the properties of a water conditioner, anti evaporation agent and viscous sludge
                                reactor.
                            </em>
                        </GradientText>
                    </div>
                </div>

                <WithSidebar Sidebar={<ProductSideBar items={relatedProductPageTitles} />}>
                    <div id={relatedProductPageTitles[0]}></div>
                    <GeneralInfoBox>
                        <h3>General information</h3>
                        <p>
                            Wuxal Р Мах is ideal for promoting the growth and development of the root system of plants
                            in the early stages of vegetation, as well as for reducing plant stress caused by phosphorus
                            or zinc deficiency.
                        </p>
                        <p>
                            The phosphorus in Wuxal Р Мах is in the form of water-soluble phosphate, which guarantees
                            fast and safe phosphorus supply to plants. It also contains nitrogen, which promotes plant
                            growth.
                        </p>
                        <p>
                            Wuxal Р Мах has the best buffering properties and neutralizes the pH of the working
                            solution, which guarantees the optimal effect of plant protection products.
                        </p>
                        <p>
                            Wuxal has been known on the Ukrainian market since 2003 and has gained a reputation as a
                            high-quality, effective and reliable means of increasing crop productivity. The technologies
                            implemented in Wuxal are one step ahead of modern cultivation technologies.
                        </p>
                        <Button type="read-more">READ MORE</Button>
                    </GeneralInfoBox>
                    <div id={relatedProductPageTitles[1]}></div>
                    <img src={aboutImage} alt="info" />
                    <div id={relatedProductPageTitles[2]}></div>
                    <BenefitsBox title="Benefits" data={data2} />
                    <div id={relatedProductPageTitles[3]}></div>
                    <ProductItemsBox title="Wuxal trial results" data={vegatables2} />
                    <div id={relatedProductPageTitles[4]}></div>
                    <ProductItemsBox title="Wuxal crop nutrition programs" data={vegatables} />
                    <div id={relatedProductPageTitles[5]}></div>
                    <ProductItemsBox title="Related products" data={products} />
                </WithSidebar>
            </div>
        </div>
    );
};

export default RelatedProduct;
